import Vue from "vue";
import Router from "vue-router";
import store from "./store";

Vue.use(Router);

let router = new Router({
    mode: "history",
    routes: [
        {
            path: "/",
            name: "home",
            props: true,
            component: () => import("./components/DashbordPage.vue"),
        },
        {
            path: "/privacypolicy",
            name: "privacypolicy",
            props: true,
            meta: { title: "Privacy Policy | PA Tours And Travels" },
            component: () => import("./../src/components/PrivacypolicyPage.vue"),
        },
        {
            path: "/termsandconditions",
            name: "termsandconditions",
            props: true,
            meta: { title: "Terms And Conditions | PA Tours And Travels" },
            component: () => import("./../src/components/termsandService.vue"),
        },
        {
            path: "/cancellationpolicy",
            name: "cancellationpolicy",
            props: true,
            meta: { title: "Privacy Policy | PA Tours And Travels" },
            component: () => import("./../src/components/CancellationPolicy.vue"),
        },
        {
            path: "/ComingSoon",
            name: "comingSoon",
            props: true,
            meta: { title: "Coming Soon | PA Tours And Travels" },
            component: () => import("./../src/components/ComingSoon.vue"),
        },
        {
            path: "/underConstruction",
            name: "UnderConstruction",
            props: true,
            component: () => import("./components/UnderConstruction.vue"),
        },
        {
            path: "/ContactUs",
            name: "ContactUs",
            props: true,
            meta: { title: "Contact Us | PA Tours And Travels" },
            component: () => import("./components/pa-website/ContactUsPage.vue"),
        },
        {
            path: "/cabServices",
            name: "cabServices",
            props: true,
            meta: { title: "Cab Services | PA Tours And Travels" },
            component: () => import("./components/pa-website/CabService.vue"),
        },
        {
            path: "/AllServices",
            name: "allServices",
            props: true,
            meta: { title: "Services | PA Tours And Travels" },
            component: () => import("./components/pa-website/AllServices.vue"),
        },
        {
            path: "/FlightDetails",
            name: "FlightDetails",
            props: true,
            meta: { title: "Book Your Flight | PA Tours And Travels" },
            component: () => import("./components/pa-website/FlightDetailsPage.vue"),
        },
        {
            path: "/OurTourPackages",
            name: "OurTourPackages",
            props: true,
            meta: { title: "Tour Packages | PA Tours And Travels" },
            component: () => import("./components/pa-website/CollageToursPage.vue"),
        },
        {
            path: "/TourPackages",
            name: "TourPackages",
            props: true,
            meta: { title: "Tour Packages | PA Tours And Travels" },
            component: () => import("./components/pa-website/TourPackages.vue"),
        },
        {
            path: "/Cabs",
            name: "Cabs",
            props: true,
            meta: { title: "Cabs | PA Tours And Travels" },
            component: () => import("./components/pa-website/CabPage.vue"),
        },
        {
            path: "/HotelDetails",
            name: "HotelDetails",
            props: true,
            meta: { title: "Stays | PA Tours And Travels" },
            component: () => import("./components/pa-website/HotelDetails.vue"),
        },
        {
            path: "/AboutUs",
            name: "AboutUs",
            props: true,
            meta: { title: "About Us | PA Tours And Travels" },
            component: () => import("./components/pa-website/AboutUsPage.vue"),
        },
         {
            path: "/enquireNow",
            name: "enquireNow",
            props: true,
            meta: { title: "Submit Your Enquiry | PA Tours And Travels" },
            component: () => import("./components/pa-website/EnquiryPage.vue"),
        },
        {
            path: "/ourServices",
            name: "ourServices",
            props: true,
            meta: { title: "Services | PA Tours And Travels" },
            component: () => import("./components/pa-website/AllServices.vue"),
        },
        {
            path: "/popularDestinations",
            name: "popularDestinations",
            props: true,
            meta: { title: "Popular Destinations | PA Tours And Travels" },
            component: () => import("./components/pa-website/PopularDestinations.vue"),
        },
        {
            path: "/reviewPage",
            name: "reviewPage",
            props: true,
            component: () => import("./components/pa-website/ReviewsPage.vue"),
        },
        
         {
            path: "/weddingCabs",
            name: "weddingCabs",
            props: true,
            meta: { title: "Wedding Cars | PA Tours And Travels" },
            component: () => import("./components/pa-website/RentaCar.vue"),
        },
        
        {
            path: '*',
            name: 'NotFound',
            component: () => import("./../src/components/NotFound.vue"),
        },
    ],
    scrollBehavior(to, from, savedPosition) {
        // Smooth scroll behavior
        if (savedPosition) {
            // When using browser back/forward buttons - smooth scroll to saved position
            return new Promise((resolve) => {
                setTimeout(() => {
                    resolve({
                        ...savedPosition,
                        behavior: 'smooth'
                    });
                }, 300); // Delay to ensure page is loaded
            });
        } else {
            // When navigating to a new route - smooth scroll to top
            return new Promise((resolve) => {
                setTimeout(() => {
                    resolve({
                        x: 0,
                        y: 0,
                        behavior: 'smooth'
                    });
                }, 300); // Delay to ensure page is loaded
            });
        }
    }
});

let loadingStartTime = null;
const MINIMUM_LOADING_TIME = 800; // Show loader for at least 800ms

// Global Navigation Guards
router.beforeEach((to, from, next) => {
    loadingStartTime = Date.now();
    store.dispatch('setLoading', true);
    next();
});

router.afterEach((to) => {

    // Set page title
    document.title = to.meta.title || "PA Tours And Travels";

    const loadingDuration = Date.now() - loadingStartTime;
    const remainingTime = Math.max(MINIMUM_LOADING_TIME - loadingDuration, 0);

    setTimeout(() => {
        store.dispatch('setLoading', false);
    }, remainingTime);
});

export default router;
